<!-- Points Summary -->
<div class="container">
  <fgb-points-summary-bar [backButtonLink]="'/rewards'"></fgb-points-summary-bar>
</div>

<div class="container mb-2">
  <div class="back-btn text-primary cursor-pointer d-none d-lg-flex align-items-center justify-content-center" (click)="goBack()">
    <span class="material-symbols-outlined ms-2 text-white"> arrow_back_ios </span>
  </div>
</div>

<fgbcl-auction-details [auctionId]="id"></fgbcl-auction-details>
